export type ObjType = {
  [key: string]: any;
};

const revenueShareTabs = ['sportsbook', 'tvcasino', 'livecasino', 'taincasino', 'pkm_poker', 'pkm_casino', 'net_deposit', 'all_casino', 'all', 'casino_slots_and_instant_games', 'live_and_tv_casino'];

export const LEGACY_VERTICAL_MAP: { [key: string]: string } = {
  taincasino: 'casino_slots_and_instant_games',
  pkm_casino: 'casino_slots_and_instant_games',
  livecasino: 'live_and_tv_casino',
  tvcasino: 'live_and_tv_casino',
};

export const LEGACY_VERTICAL_PAIR: { [key: string]: string } = {
  taincasino: 'pkm_casino',
  pkm_casino: 'taincasino',
  livecasino: 'tvcasino',
  tvcasino: 'livecasino',
};

export const getRevenueShareTabsList = (constants: ObjType, type: string): string[] => {
  /*return type === 'hybrid'
    ? Object.keys(constants[type].revenue_share).sort()
    : Object.keys(constants[type]).sort();*/
  return revenueShareTabs;
}

export const getStepsByProduct = (array: ObjType[], product: string | null): ObjType[] => {
  return array.reduce((acc: ObjType[], item: ObjType, i: number) => {
    if (item.product === product) {
      acc.push({
        index: i,
        data: item,
      })
    }

    return acc;
  }, [])
}

export const getDisabledOptionCpaDealConditionForComparison = (value: string, options?: string[]) => {
  switch(value) {
    case "":
      return ['==', '<=', '<'];
    case "first_deposit_sum":
      return ['==', '<=', '<'];
    case "deposits":
      return ['==', '<=', '<'];
    case "sportsbook_ggr":
      return ['==', '<=', '<'];
    case "casino_ggr":
      return ['==', '<=', '<'];
    case "poker_rake_sum":
      return ['==', '<=', '<'];
    case "total_ggr":
      return ['==', '<=', '<'];
    case "sportsbook_bet_count":
      return ['==', '<=', '<'];
    case "sportsbook_stakes":
      return ['==', '<=', '<'];
    case "casino_bet_count":
      return ['==', '<=', '<'];
    case "casino_wager":
      return ['==', '<=', '<'];
    case "total_turnover":
      return ['==', '<=', '<'];
    case "deposits_count":
      return ['==', '<=', '<'];
    default:
      return [];
  }
}

export const getDisabledOptionRsPaymentColumn = (options: string[]) => {
  return options.reduce((acc: string[], item) => {
    if (!item.includes('ngr') && !item.includes('ggr') && !item.includes('turnover')) {
      acc.push(item);
    }
    return acc;
  }, [])
}

export const getDisabledOptionRsVertical = (options: string[], selected: string[]) => {
  const disabled: string[] = [];

  selected.forEach((sel) => {
    if (options.includes(sel)) {
      disabled.push(sel);
    }

    if (LEGACY_VERTICAL_MAP[sel]) {
      disabled.push(LEGACY_VERTICAL_MAP[sel]);
    }
  });

  if (selected.includes('all')) {
    disabled.push('sportsbook', 'tvcasino', 'livecasino', 'taincasino', 'pkm_poker', 'pkm_casino', 'all_casino', 'live_and_tv_casino', 'casino_slots_and_instant_games');
  }

  if (selected.includes('all_casino')) {
    disabled.push('tvcasino', 'livecasino', 'taincasino', 'pkm_casino', 'all', 'live_and_tv_casino', 'casino_slots_and_instant_games');
  }

  if (selected.includes('casino_slots_and_instant_games')) {
    disabled.push('taincasino', 'pkm_casino', 'all_casino', 'all');
  }

  if (selected.includes('live_and_tv_casino')) {
    disabled.push('tvcasino', 'livecasino', 'all_casino', 'all');
  }

  if (selected.includes('sportsbook') || selected.includes('pkm_poker')) {
    disabled.push('all');
  }

  if (selected.includes('pkm_casino') || selected.includes('taincasino')) {
    disabled.push('all', 'all_casino', 'casino_slots_and_instant_games');
  }

  if (selected.includes('tvcasino') || selected.includes('livecasino')) {
    disabled.push('all', 'all_casino', 'live_and_tv_casino');
  }

  return [...new Set(disabled)];
}

export const getDisabledOptionRsConditionForComparison = (options: string[]) => {
  return options.reduce((acc: string[], item) => {
    if (item !== 'any') {
      acc.push(item);
    }
    return acc;
  }, [])
}

export const getDefaultValueRsPaymentColumn = (options: string[]) => {
  return options.reduce((acc: string[], item) => {
    if (item.includes('ngr')) {
      acc.push(item);
    }
    return acc;
  }, [])[0]
}

export const getDefaultValueRsObtainedResult = (options: string[]) => {
  return options.reduce((acc: string[], item) => {
    if (item.includes('ngr')) {
      acc.push(item);
    }
    return acc;
  }, [])[0]
}

export const getConditionFiltersAttributes = (
  array: { [key: string]: any }[],
  type: string,
  removedConditionItems: any[],
  removedConditionFilters: any[],
): any[] => {
  let new_array:any[] = [];
  new_array = array.reduce((acc: ObjType[], item: { [key: string]: any }) => {
    // const value = item.value.reduce((acc: string[], item: { [key: string]: any }) => {
    //       acc.push(item.id);
    //       return acc;
    //     }, []);

    const removedItems = removedConditionItems.length > 0
      ? removedConditionItems.reduce((acc: any[], item: any) => {
        acc.push({
          ...item,
          _destroy: 1
        });
        return acc;
      }, [])
      : [];

    const condition_items_attributes = (type === 'cpa' || type === 'hybrid')
      ? item.condition_items_attributes
      : [];

    const condition_steps_attributes = type === 'hybrid'
      ? item.condition_steps_attributes
      : item.condition_steps_attributes.filter((el: ObjType) => el.type_in_part_condition === type);

    acc.push({
      ...item,
      condition_items_attributes: [...condition_items_attributes, ...removedItems],
      condition_steps_attributes: condition_steps_attributes,
      value: {
        brands: item.value.brands,
        ...(!!item.value.countries && item.value.countries.length > 0 ? { countries: item.value.countries } : {}),
        ...(!!item.value.currencies && item.value.currencies.length > 0 ? { currencies: item.value.currencies } : {}),
      }
    });

    return acc;
  }, []);

  new_array.push(...removedConditionFilters);

  return new_array;
}

export const updateCountrCurr = (
    brandsList: any,
    currentFilter: any
):any => {
  const selectedRow = currentFilter.value.brands.reduce((acc: any[], code:string) => {
    const selectedItem = brandsList.list.filter((row:any) => row.code === code);
    acc.push(...selectedItem);
    return acc
  },[]);

  const countries = selectedRow.reduce((acc:any, item:any) => {
    const selected_countries = item.countries.filter((id1:any) => !acc.some(( id2:any) => id2 === id1));
    acc.push(...selected_countries);
    return acc;
  }, []);

  const currencies = selectedRow.reduce((acc:any, item:any) => {
    const new_currencies = item.currencies.filter((id1:any) => !acc.some(( id2:any) => id2 === id1));
    acc.push(...new_currencies);
    return acc;
  }, []);

  const selected_country = countries.filter((id1:any) => currentFilter.value.countries.some((id2:any) => id2 === id1));
  const selected_currency = currencies.filter((id1:any) => currentFilter.value.currencies.some((id2:any) => id2 === id1));

  const updatedFilter = {
    countries: selected_country,
    currencies: selected_currency,
  }

  return updatedFilter;
}
